import React from 'react'
import ReactDOM from 'react-dom'

import axios from 'axios'
import NumberFormat from 'react-number-format';

import Moment from 'moment'
import 'react-dates/initialize';
import { SingleDatePicker } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';

Moment.locale('en-gb');

import ProcessButton from '../../shared/process-button'
import TimeSelect from './time-select'


import ReactModal from 'react-modal';
ReactModal.setAppElement('body');

const ModalStyles = {
  overlay: {
	  backgroundColor: 'rgba(0, 0, 0, 0.75)'
  },
  content : {
	padding				  : '2rem',
	width				  : 'auto',
	maxWidth			  : '900px',
	height				  : 'auto',
	maxHeight             : '90%',
	top                   : '50%',
	left                  : '50%',
	right                 : 'auto',
	bottom                : 'auto',
	marginRight           : '-50%',
	transform             : 'translate(-50%, -50%)'
  }
};


class Form extends React.Component {

	constructor(props) {

		super(props);

		this.state = {
			price: this.defaultPrice(),
			showFromPrice:  this.defaultShowFromPrice(),
			formData: {
				pax: this.props.defaults.pax,
				date: this.props.defaults.date != null ? this.parseDate( this.props.defaults.date ) : null,
				time: this.props.defaults.time || '',
				price_id: this.props.defaults.price_id || 0,
				message_text: "Hi " + this.props.product.supplier.name + ",\n\nPlease can you let me know if you have availability for the date and time I have requested. Thanks!",
			},
			email: '',
			showModal: false,
			focused: null,
			process: false
		}
	}


	defaultPrice = () => {
		return this.props.defaults.price_id > 0 ? this.props.defaults.price : this.props.product.fromPrice;
	}
	
	defaultShowFromPrice = () => {
		return this.props.defaults.price_id > 0 ? false : this.props.product.showFromPrice;
	}
	
	hasTimePrices = () => {
		return false;
	}
	
	/*
	####################
	##  DATE HELPERS  ##
	####################
	*/

	parseDate = (date) => {
		if( date == null ) {
			return null;
		}
		let objDate = Moment();
		const dateParts = date.split('/');
		objDate.set('year', Number(dateParts[2]) );
		objDate.set('month', Number(dateParts[1])-1 );
		objDate.set('date', Number(dateParts[0]) );
		objDate.set('hour', 4 );
		objDate.set('minute', 0);
		objDate.set('second', 0 );
		objDate.set('millisecond', 0);

		return objDate;
	}
	
	/*
	##################
	##  PAX SELECT  ##
	##################
	*/

	handlePaxChange = ( event ) => {
		if( event.target.value > 0 ) {

			const formData = this.state.formData;
			formData.pax = event.target.value;

			this.setState({
				formData: formData
			});
		} else {

			const formData = this.state.formData;
			formData.pax = 0;

			this.setState({
				formData: formData,
				formStatus: this.setFormStatusStep(0),
				price: this.defaultPrice(),
				showFromPrice: this.defaultShowFromPrice()
			});
		}

	}

	/*
	###################
	##  DATE PICKER  ##
	###################
	*/
	blocksDay = (day) => {
		//can't select day in the past
		if( day.isBefore( Moment(), "day" ) ) {
			return true;
		} else {
			//in blackouts?
			if( this.props.blackouts.length > 0 ) {
				if( this.props.blackouts.indexOf( day.format('YYYY-MM-DD') ) != -1 ) {
					return true;
				}
			}
		}
	}

	handleDateChange = ( date ) => {

		const formData = this.state.formData;
		formData.date = date;

		let reopenTimeSelect = false;

		if( this.hasTimePrices() && formData.time.length > 0 ) {
			formData.time = '';
			reopenTimeSelect = true;
		}
		this.setState({
			formData: formData
		});
	}
	
	/*
	###################
	##  TIME SELECT  ##
	###################
	*/

	handleTimeChange = (event) => {
		if( !this.hasTimePrices() ) {
			const formData = this.state.formData;
			formData.time = event.target.value;
			formData.price_id = 0;
			this.setState({
				formData: formData
			});
		}
	}
	
	/*
	######################
	##  ENQUIRE BUTTON  ##
	######################
	*/

	enquireButtonStatus = () => {
		return this.state.formData.pax > 0 && this.state.formData.date != null && this.state.formData.time.length > 1 ? true : false
	}

	handleClick = ( event ) =>  {

		event.preventDefault();

		this.setState( {showModal: true } );
	}
	
	/*
	#######################
	##  MODAL FUNCTIONS  ##
	#######################
	*/
	handleCloseModal = () => {
		this.setState({ showModal: false });
	}
	
	
	handleEmailAddress = ( event ) => {
		this.setState({ email: event.target.value });
	}
	
	handleSubmit = () => {
		this.setState({ process: true });
		const url = '/products/' + this.props.product.id + '/register';
			axios.post( url, {
					authenticity_token: this.props.token,
					email: this.state.email
			}).then( response => {
				window.location.replace( '/products/register/success' );
			}).catch(err => {
				this.setState({ process: false });
			});
	}
	
	/*
	########################
	##  RENDER FUNCTIONS  ##
	########################
	*/
	renderMinMax = () => {
		if( this.props.product.min > 0 && this.props.product.max > 0 ) {
			const items = [];
			if( this.props.product.min > 0 ) {
				items.push( '<b>Min:</b> ' + this.props.product.min );
			}

			if( this.props.product.max > 0 ) {
				items.push( '<b>Max:</b> ' + this.props.product.max );
			}
			return {__html: items.join( ', ' ) + ' people'};
		} else {
			return null;
		}
	}


	render() {

		const formErrors = this.props.errors.length ? this.props.errors : false;

		const paxClass = 'input-group guests animated';
		const dateClass = 'input-group date animated';
		const timeClass = 'input-group time animated';

		return (
			<form name="productForm" ref="productForm" className="new_booking" id="new_booking" action={this.props.product.url + `/booking`} acceptCharset="UTF-8" method="post">
				<input name="utf8" type="hidden" value="&#x2713;" />
				<input name="authenticity_token" value={this.props.token} type="hidden" />
				{!this.props.status? (
					<input name="view" value="extended" type="hidden" />
				) : null }
				<input name="booking[product_id]" value={this.props.product.id} type="hidden" />
				<input name="time" value={this.state.formData.time} type="hidden" />
				<input name="price_id"value={this.state.formData.price_id} type="hidden" />
				<input name="message_text" value={this.state.formData.message_text} type="hidden" />


				{ formErrors ?
					<ul>
						{formErrors.map((error, index) => {
							return (
								<li key={`error` + index}>{error}</li>
							)
						})}
					</ul>
					: null
				}

				<p className="text-center pricing" itemProp="offers" itemScope itemType="http://schema.org/Offer">
					{this.state.showFromPrice ? <span className="small-text">from </span> : null }
					<b><span itemProp="priceCurrency" content="GBP">£</span><NumberFormat itemProp="price" content={this.state.price} value={this.state.price} displayType={'text'} thousandSeparator={true} prefix="" decimalScale={2} fixedDecimalScale={true} /></b> <span className="small-text"><span itemProp="priceCurrency" content="GBP">{this.props.product.fixedPrice ? 'Per group' : 'per person'}</span></span>
				</p>
        		<div className="divider"></div>
				<div className="product-view__product-details--availability clearfix">
					<div className="grid-x grid-margin-x">
						<div className="small-12 cell">
							<p dangerouslySetInnerHTML={this.renderMinMax()} />
						</div>
						<div className="small-12 cell">
							<div className={paxClass}>
								<select name="pax" value={this.state.formData.pax} onChange={this.handlePaxChange}>
									<option value="0" key="pax-0">Guests</option>
									{this.props.product.paxRange.map((p, index) => {
										return (
											<option key={`pax-` + p} value={p}>{p} people</option>
										)
									})}
								</select>
							</div>
						</div>
						<div className="small-12 cell">
							<div className={dateClass}>
								<SingleDatePicker
									date={this.state.formData.date}
									onDateChange={this.handleDateChange}
									onFocusChange={({ focused }) =>
										this.setState({ focused })
									}
									focused={this.state.focused}
									isOutsideRange={this.blocksDay}
									showDefaultInputIcon={true}
									inputIconPosition="after"
									numberOfMonths={1}
									hideKeyboardShortcutsPanel={true}
									readOnly={true}
									displayFormat="DD/MM/YYYY"
									withFullScreenPortal={window.matchMedia("(max-width: 768px)").matches}
									disabled={false}
								 />
							</div>
						</div>

						<div className="small-12 cell">
							<div className={timeClass}>
								<TimeSelect
									active={true}
									value={this.state.formData.time}
									handleTimeChange={this.handleTimeChange}
								/>
							</div>
						</div>
					</div>


					<div className="clearfix enquire-btn">
						<ProcessButton
							onClickHandler={this.handleClick}
							buttonClass={ `button primary expanded` + ( this.enquireButtonStatus() == false ? ` disabled` : null )}
							disabled={!this.enquireButtonStatus()}
						>
							Enquire now!
						</ProcessButton>
					</div>

				</div>


				<ReactModal isOpen={this.state.showModal} contentLabel="Login/Register" style={ModalStyles}>
					<button onClick={this.handleCloseModal} className="close-button" aria-label="Close modal">
						<span aria-hidden="true">×</span>
					</button>
					<h4 class="bold">Unfortunately our 2024 christmas packages aren't ready yet!</h4>
					<p>Enter your email address below to be notified when the new packages are live on our website.</p>
					<div className="grid-x">
						<div className="column medium-8">
							<div className="align-content vertical center gap">
							
								<input type="text" value={this.state.email} placeholder="Your email address" onChange={this.handleEmailAddress} />
							
								<ProcessButton
									onClickHandler={this.handleSubmit}
									buttonClass="button medium primary no-mg-b"
									disabled={this.state.email.length < 3}
									process={this.state.process}
								>
									Submit
								</ProcessButton>
								
							</div>
						</div>
					</div>
				</ReactModal>

			</form>
		)
	}
}

document.addEventListener('DOMContentLoaded', () => {
	const form = document.querySelector('#product-form');

	let product = JSON.parse(form.getAttribute('product'));
	product.showFromPrice = product.showFromPrice == '1' ? true : false;

	const token = form.getAttribute('token');
	const defaults = JSON.parse(form.getAttribute('defaults') );
	const status = form.getAttribute('status') == 'true' ? true : false;
	const errors = JSON.parse(form.getAttribute('errors'));
	const blackouts = JSON.parse(form.getAttribute('blackouts'));
	const view = form.getAttribute('view');


	/*
	const pax_range = JSON.parse(form.getAttribute('pax_range'));
	const fromPrice = form.getAttribute('fromPrice');
	const showFromPrice = form.getAttribute('showFromPrice') == 'true' ? true : false;
	const min = form.getAttribute('min');
	const max = form.getAttribute('max');
	const grid = form.getAttribute('grid') == 1 ? true : false;
	const productId = form.getAttribute('productId');
	const url = form.getAttribute('url');
	*/


	ReactDOM.render(
		<Form
			product={product}
			token={token}
			defaults={defaults}
			status={status}
			errors={errors}
			blackouts={blackouts}
			view={view}
		/>,
		form,
	)
})
